import React from 'react';
import '../Styles/Blog.css';
import SEO from '../components/SEO';

const Cases = () => {
  return (
    <div className="blog-container">
      <SEO
        title="Sample Agreements & Case Studies — Contract Specialist"
        description="Explore sample contract agreements and real-world case studies from Pooja Biswal — covering NDAs, service agreements, freelance contracts and commercial disputes."
        keywords="sample contract agreements UK, NDA template, service agreement sample, freelance contract examples, contract case studies, commercial contract templates"
        canonical="/cases"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Cases", path: "/cases" }]}
      />
      <div className="blog-section">
        <div className="blog-content-wrapper">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            <h1 className="section-title">
              Sample Agreements & Cases
            </h1>
            <p style={{
              fontSize: '1.1rem',
              color: '#666666',
              lineHeight: '1.7'
            }}>
              Coming soon...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cases;